import React, { useEffect, useState } from 'react';

import { Col, Row } from 'antd';
import './external-resources.scss';
import { ExternalResourceSlide } from '/react4xp/parts/external-resources/components/external-resource-slide';
import { getExtResList } from '/react4xp/parts/service-link-img/actions';

const ExternalResources = (props: any) => {
    const [frames, setFrames] = useState<any[]>();

    useEffect(() => {
        getExtResList(props.language, 'com.enonic.cms.ru').then((value) => {
            setFrames(value.data);
        });
    }, []);

    return (
        <div className="external-resources-block">
            <h3>{props.config.title}</h3>

            <Row gutter={[16, 16]}>
                {frames?.map(({ id, title, imageSrc, url }) => (
                    <Col
                        key={id}
                        xs={24}
                        md={12}
                        xl={8}
                    >
                        <ExternalResourceSlide
                            key={id}
                            title={title}
                            url={url}
                            imageSrc={imageSrc}
                        />
                    </Col>
                ))}
            </Row>

            {/* {frames ? (
                <Carousel
                    autoplay
                    autoplaySpeed={7000}
                    arrows
                    ref={carouselRef}
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                >
                    {frames.map((frame, index) => (
                        <div
                            className="slides-frame"
                            key={index}
                        >
                            {frame.map(({ id, title, imageSrc, url }) => (
                                <ExternalResourceSlide
                                    key={id}
                                    title={title}
                                    url={url}
                                    imageSrc={imageSrc}
                                    size={slideSize}
                                />
                            ))}
                        </div>
                    ))}
                </Carousel>
            ) : (
                <Carousel
                    autoplay
                    autoplaySpeed={7000}
                    arrows
                    ref={carouselRef}
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                >
                    <div className="slides-frame" >
                        <Skeleton.Image active={true} />
                        <Skeleton.Image active={true} />
                        <Skeleton.Image active={true} />
                    </div>
                </Carousel>
            )} */}
        </div>
    );
};

export default ExternalResources;
